import { render, staticRenderFns } from "./ImportExportSetup.vue?vue&type=template&id=3f43a2b9&scoped=true&"
import script from "./ImportExportSetup.vue?vue&type=script&lang=js&"
export * from "./ImportExportSetup.vue?vue&type=script&lang=js&"
import style0 from "./ImportExportSetup.vue?vue&type=style&index=0&id=3f43a2b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43a2b9",
  null
  
)

export default component.exports